module.exports = __webpack_public_path__ + "img/new_facesheet.4327ef6c.svg";